/**
 * File: youtubePreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class youtubesPreviewController {
    // @ngInject
    constructor($scope, $state, $rootScope, $sce, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let plan = localStorageService.get("currentPlan")
        console.log(plan)
        let authoring = localStorageService.get("authoringData")
        let resourceId = $state.params.resourceId;

        $scope.toogleResource = "Show Details";
        var screenLen = screen.width;
        if (screenLen < 1281) {
            $scope.isShow = false;
        } else {
            $scope.isShow = true;
        }

        $scope.gotoSite = (site) => {
            if (site.indexOf("http") === -1) {
                site = "http://" + site
            }
            window.open(site, "_blank")

        }

        //Show details of WebLinks
        $scope.viewResource = () => {
            $scope.isShow = !$scope.isShow
            $scope.toogleResource = $scope.isShow ? "Hide Details" : "Show Details"
        }

        var loadTemplate = () => {
            console.log(resourceId)
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })

                if ($scope.userPrev.viewYoutuVideos && $scope.userPrev.viewYoutuVideos.read && ($scope.userPrev.addYoutubeLinks == undefined || ($scope.userPrev.addYoutubeLinks && !$scope.userPrev.addYoutubeLinks.create)) && ($scope.userPrev.approveYoutubeLinks == undefined || ($scope.userPrev.approveYoutubeLinks && !$scope.userPrev.approveYoutubeLinks.create))) {
                    try {
                        var data = {
                            resource: {
                                type: $scope.resource.type,
                                subject_id: authoring.subject_id,
                                class_id: authoring.class_id,
                                curriculum_id: authoring.curriculum_id,
                                batch_id: authoring.batch_id,
                                session_id: authoring.session_id,
                                school_id: authoring.school_id,
                                theme_id: plan.theme_id,
                                plan_id: planId,
                                progress_data: {
                                    _id: resourceId,
                                    title: $scope.resource.title
                                }
                            },
                            user_id: userId
                        }
                        authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, () => {})
                    } catch (ex) {}

                }
                if ($scope.resource) {
                    if ($scope.resource.youtube_link) {
                        $scope.isAvailable = true
                        $scope.src = $scope.resource.youtube_link
                        var video_id = $scope.src.split('v=')[1] ? $scope.src.split('v=')[1].split('&')[0] : undefined;
                        if (!video_id) {
                            let splitedSrc = $scope.src.split('/')
                            video_id = splitedSrc[splitedSrc.length - 1]
                        }
                        $scope.src = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + video_id + "?modestbranding=1;&rel=0");
                    }
                }
                _.defer(() => {
                    $scope.$apply();
                });
            }
        }
       
         /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "utubeVideo"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }
    };
}

export default youtubesPreviewController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/utubeVideoPreview.js